import Text from "../../../components/ui/Text";
import { truncString } from "../../walkie-talkie/helpers";
import bottomShadowImage from "../assets/images/Ellipse 10.png";
import bottomShadowBlueImage from "../assets/images/blue-elipse.png";
import clickSound from "../../../assets/audio/click.wav";
import { useAudioEffects } from "../../../hooks/use-audio-effects";

interface Props {
  className?: string;
  title: string;
  description: string;
  imageSrc: string;
  skillLevel?: number;
  buttonLabel?: string;
  buttonLabelSelected?: string;
  isHighlighted?: boolean;
  /** Whether this card is currently selected */
  isSelected?: boolean;
  /** Whether this card is disabled */
  isDisabled?: boolean;
  /** Callback when user clicks the card */
  onSelect?: () => void;
}

const TransportCard = ({
  className = "",
  isSelected,
  imageSrc,
  title,
  description,
  skillLevel,
  isHighlighted,
  buttonLabel = "Select",
  buttonLabelSelected = "Selected",
  onSelect,
  isDisabled,
}: Props) => {
  const { playEffect } = useAudioEffects();

  return (
    <article
      className={`${
        isDisabled && "opacity-70 cursor-not-allowed"
      } 1520px:max-w-[330px] ${className} `}
    >
      <div
        className={`rounded-md border-[1px]  gilroy-font ${
          isHighlighted ? "border-[#56F5FF]/50" : "border-white/10"
        }`}
      >
        <div
          style={{ backdropFilter: "blur(5px)" }}
          className={` min-h-[320px] 1520px:min-h-[380px] pb-5 flex flex-col justify-between relative rounded-md ${
            isHighlighted ? " bg-[#56F5FF]/10" : "bg-[#888888]/5"
          }`}
        >
          {/** Skill */}
          <div className="flex justify-end mr-5 mt-[-22px] z-[5]">
            <div
              className={`w-[103px] h-[42px] rounded-md flex items-center justify-center  ${
                isHighlighted
                  ? "bg-gradient-to-b from-[#98D84B] to-[#507226] border-[1px] border-[#98D84B] text-white"
                  : "bg-gradient-to-r from-white to-white/70 text-black/70 "
              }`}
            >
              <Text size="xs" className="!font-[400]">
                Skill {skillLevel}
              </Text>
            </div>
          </div>

          {/** Image */}
          <div className="w-full overflow-hidden">
            <div className="relative right-[-31px]">
              <img
                src={imageSrc}
                alt="Plane"
                className="w-full h-full max-w-[250px] 1520px:max-w-[339px] max-h-[225px] object-contain"
              />
            </div>
          </div>

          {/** Info */}
          <div>
            {/** Splitted name */}
            <div className="flex flex-wrap gap-1 justify-center items-center text-center px-5">
              {truncString(title, 24)
                ?.split(" ")
                ?.map((word, index) => (
                  <Text
                    size="md"
                    key={index}
                    className={`text-white uppercase ${
                      index === 0 ? "!font-[30]" : "!font-semibold"
                    }`}
                  >
                    {word}
                  </Text>
                ))}
            </div>

            {/** desc */}
            <Text
              size="xxs"
              className="text-white/50 text-center text-wrap max-w-[70%] mx-auto leading-5 mt-1"
            >
              {description}
            </Text>
          </div>
          {/** Shadow from bottom */}
          <img
            alt="shadow"
            src={isHighlighted ? bottomShadowBlueImage : bottomShadowImage}
            className="absolute bottom-0 left-0 right-0 w-full max-h-[233px] z-[-1]"
          />
        </div>
      </div>

      {/** Button */}
      <button
        className={`p-3 w-full rounded-md mt-3 transition duration-300 active:scale-95
    ${
      isHighlighted
        ? "border border-[#56F5FF]/20 " +
          "bg-[linear-gradient(to_right,rgba(17,37,48,0.5)_5%,#204b55_50%,rgba(17,37,48,0.5)_95%)] " +
          "hover:bg-[linear-gradient(to_right,rgba(17,37,48,0.7)_5%,#204b55_50%,rgba(17,37,48,0.7)_95%)]"
        : "bg-[linear-gradient(to_right,rgba(255,255,255,0.1)_5%,rgba(255,255,255,0.2)_50%,rgba(255,255,255,0.1)_95%)] " +
          "hover:bg-[linear-gradient(to_right,rgba(255,255,255,0.15)_5%,rgba(255,255,255,0.25)_50%,rgba(255,255,255,0.15)_95%)]"
    }`}
        title={buttonLabel}
        onClick={() => {
          if (onSelect) onSelect();
          playEffect(clickSound);
        }}
      >
        <Text size="xxs" className="text-center text-white">
          {isSelected ? buttonLabelSelected : buttonLabel}
        </Text>
      </button>
    </article>
  );
};

export default TransportCard;
